import * as React from 'react'
import * as styles from './Smile.module.scss'

interface SmileProps {
  width: number
  height: number
}

const Smile = ({width, height}: SmileProps) => (<div style={{ paddingTop: `calc((100% * ${height}/${width}) - 1px)` }} className={styles.NoImgSmile}></div>)

export default Smile
